const RIGHT_PANEL_CONFIGURE__STORAGE_KEY = 'rightConfigurePopupSettings'
const RIGHT_PANEL_CONFIGURE__EXPIRATION_TIME = (typeof window !== 'undefined' && window.CACHE_EXPIRATION && window.CACHE_EXPIRATION.PERSISTENT)
  ? window.CACHE_EXPIRATION.PERSISTENT
  : null;


document.addEventListener("DOMContentLoaded", function() {
    const popupContainer = document.querySelector('#right-configure-pop-up');
    const htmlElements = {
        chartTypeVariantsContainer: popupContainer.querySelector('.item[data-key="chartType"] .variants-container'),
        chartTypeVariants: popupContainer.querySelectorAll('.item[data-key="chartType"] .variant'),
        showExtendedHours: popupContainer.querySelector('.item[data-key="showExtendedHours"]'),
        showEvents: popupContainer.querySelector('.item[data-key="showEvents"]'),
    }
    let currentData = {};

    initPopupSettingsComponent()
    setListeners()




    function initPopupSettingsComponent() {
        const defaultData = {
            "chartType": "Mountain",
            "showExtendedHours": false,
            "showEvents": false,
        }
        currentData = _loadSettings() || defaultData;
        updatePopup(currentData);
    }


    function updatePopup() {

        // chart type
        const chartTypes = ['Mountain', 'Line', 'Candlestick'];
        const typeIndex = chartTypes.indexOf(currentData.chartType);
        htmlElements.chartTypeVariantsContainer.style.setProperty('--selected-index', typeIndex);
        htmlElements.chartTypeVariants.forEach((el => el.classList.remove('selected')));
        htmlElements.chartTypeVariants[typeIndex].classList.add('selected');


        // extended hours and events
        htmlElements.showExtendedHours.classList.toggle('selected', currentData.showExtendedHours);
        htmlElements.showEvents.classList.toggle('selected', currentData.showEvents);
    }


    function setListeners() {
        htmlElements.chartTypeVariants.forEach((el, index) => {
            el.addEventListener('click', () => {
                const chartTypes = ['Mountain', 'Line', 'Candlestick'];
                currentData.chartType = chartTypes[index];

                applyChangesToChart('chartType');
                _saveSettings();
                updatePopup();

                if (window.gtag) gtag('event', `Desktop_RightPanel_LiveChart_Settings_${chartTypes[index]}`);
            })
        })

        htmlElements.showExtendedHours.addEventListener('click', () => {
            currentData.showExtendedHours = !currentData.showExtendedHours;

            applyChangesToChart('showExtendedHours');
            _saveSettings();
            updatePopup();

            if (window.gtag) gtag('event', `Desktop_RightPanel_LiveChart_Settings_KeyEvents${currentData.showExtendedHours ? 'On' : 'Off'}`);
        })

        htmlElements.showEvents.addEventListener('click', () => {
            currentData.showEvents = !currentData.showEvents;

            applyChangesToChart('showEvents');
            _saveSettings();
            updatePopup();
        })
    }

    function applyChangesToChart(changedKey) {
        const stockChart = document.getElementById('stock-chart');
        if (!stockChart) return


        switch (changedKey) {
            case 'chartType':
                stockChart.setAttribute('tradingview-universal-chart', {
                    type: currentData.chartType.toLowerCase()
                });
                break
            case 'showExtendedHours':
                stockChart.setAttribute('tradingview-universal-chart', {
                    showExtendedHours: currentData.showExtendedHours
                })
                break
            case 'showEvents':
                stockChart.setAttribute('tradingview-universal-chart', {
                    showEvents: currentData.showEvents
                })
                break
        }
    }

    function _loadSettings() {
        try {
            if (typeof window.getCacheItem !== 'function') { throw new Error('[right-configure-popup] storage-management not loaded (window.getCacheItem missing)'); }
            const data = window.getCacheItem(RIGHT_PANEL_CONFIGURE__STORAGE_KEY);
            return data;
        } catch (e) {
            if (__LOG_WARN__) AppLog.warn('Failed to load right configure popup settings', e);
            return null;
        }
    }

    function _saveSettings() {
        try {
            const payload = {};
            Object.keys(currentData).forEach((key) => {
                payload[key] = currentData[key];
            });
            if (typeof window.setCacheItem !== 'function') { throw new Error('[right-configure-popup] storage-management not loaded (window.setCacheItem missing)'); }
            window.setCacheItem(RIGHT_PANEL_CONFIGURE__STORAGE_KEY, payload, RIGHT_PANEL_CONFIGURE__EXPIRATION_TIME);
        } catch (e) {
            if (__LOG_WARN__) AppLog.warn('Failed to save right configure popup settings', e);
        }
    }
})



